export default ({ request }) => ({
    ecomHxFtyPurchaseDetailListingApi(data = {}) {
      return request({
        url: '/ecom/hx/fty/purchase/detail/listing',
        method: 'POST',
        data,
      })
    },
    ecomHxFtyPurchaseDetailListingTotalApi(data = {}) {
      return request({
        url: '/ecom/hx/fty/purchase/detail/listingTotal',
        method: 'POST',
        data,
        timeout: 30000,
      })
    },
    ecomHxFtyPurchaseDetailDetailApi(data = {}) {
      return request({
        url: '/ecom/hx/fty/purchase/detail/detail',
        method: 'POST',
        data,
      })
    },
    ecomHxFtyPurchaseDetailUpdateShippedApi(data = {}) {
      return request({
        url: '/ecom/hx/fty/purchase/detail/update/shipped',
        method: 'POST',
        data,
      })
    },
    ecomHxFtyPurchaseDetailShippedApi(data = {}) {
      return request({
        url: '/ecom/hx/fty/purchase/detail/shipped',
        method: 'POST',
        data,
      })
    },
  })
  